import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bestätigungsdialog beim Schließen mit ungespeicherten Änderungen (z. B. AblaufDB-Editor).
 */
function ConfirmCloseDialog({ open, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <div
      className="dialog-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div className="dialog-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3>⚠️ {t('dialog.confirm_close.title')}</h3>
        </div>
        <div className="dialog-content">
          <p>{t('dialog.confirm_close.message')}</p>
        </div>
        <div className="dialog-actions">
          <button className="btn btn-secondary" onClick={onCancel} type="button">
            {t('dialog.cancel')}
          </button>
          <button
            className="btn btn-danger"
            onClick={onConfirm}
            type="button"
          >
            {t('dialog.confirm_close.discard')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmCloseDialog;
